import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>பத்திரிகை மாதிரிகள்</h1>
  <h2>ஸ்ரீவைஷ்ணவர்கள் பத்திரிகை வடிவமைக்க உதவியாக சில மாதிரிகளை இங்கே தந்துள்ளோம். </h2>
  
       <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z4">
        <mat-tab label=" சுபம் " >  
      <div class="head2">சுபங்களுக்கான பத்திரிகை மாதிரிகள்</div>
      <ion-button  expand="full"  (click)="downloadAndOpenPdf('AyushyaHomamVK.pdf')">ஆயுஷ்யஹோமம் வடகலை </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('AyushyaHomamIyer.pdf')">ஆயுஷ்யஹோமம் ஐயர் </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('AyushyaHomamVKMadam.pdf')">ஆயுஷ்யஹோமம் அஹோபில மடம் </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('AyushyaHomamVKsans.pdf')">ஆயுஷ்யஹோமம் ஆண்டவன் </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('grihapravesamTK.pdf')">க்ருஹப்ரவேசம் தென்கலை </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('grihapravesamVKAndavan.pdf')">க்ருஹப்ரவேசம் ஆண்டவன் </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('grihapravesamVKMadam.pdf')">க்ருஹப்ரவேசம் அஹோபில மடம் </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('lagnapathrikaVK.pdf')">லக்ன பத்திரிகை வடகலை</ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('nichayamVKAndavan.pdf')">நிச்சயதார்த்தம் ஆண்டவன் </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('vivahamTK.pdf')">திருமணம் தென்கலை</ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('vivahamVKAndavan.pdf')">திருமணம் வடகலை </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('seemanthamVK.pdf')">சீமந்தம் வடகலை </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('seemanthamVKAndavan.pdf')">சீமந்தம் ஆண்டவன்</ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('shashtipoorthiTK.pdf')">ஷஷ்டியப்த பூர்த்தி தென்கலை </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('shashtipoorthiVKMadam.pdf')">ஷஷ்டியப்த பூர்த்தி அஹோபில மடம் </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('sathabhishegamTK.pdf')">சதாபிஷேகம் தென்கலை </ion-button>
 <ion-button  expand="full"  (click)="downloadAndOpenPdf('sathabhishegamVKAndavan.pdf')">சதாபிஷேகம் ஆண்டவன் </ion-button>
</mat-tab>
<mat-tab label=" அபரம் " >
      <div class="head2">அபர சர்ம ச்லோக கார்டுகள் மாதிரிகள்</div>
      <img src="http://www.brahminsnet.com/invitations/charma-card-01.JPG" />
      <hr class="orange">
      <img src="http://www.brahminsnet.com/invitations/charma-card-02.JPG" />
      <hr class="orange">
      <img src="http://www.brahminsnet.com/invitations/charma-card-03.JPG" />
      <hr class="orange">
      <img src="http://www.brahminsnet.com/invitations/charma-card-04.JPG" />
      <hr class="orange">
      <img src="http://www.brahminsnet.com/invitations/charma-card-05.JPG" />
      <hr class="orange">
      <img src="http://www.brahminsnet.com/invitations/charma-card-06.jpg" />
    </mat-tab>
  </mat-tab-group>`;

const ModelInvitationsPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="பத்திரிகை மாதிரிகள் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default ModelInvitationsPage;
